import React, { useEffect, useState } from 'react';
import {
  Title,
  Content,
  Image,
  ListWrapper,
  SelectWrapper,
  LoaderWrapper,
  Disclaimer
} from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchCategories, hydrateDataSelectCategories } from '@app/src/views/Home/listProducts';
import {
  CardPackage,
  fetchPackage,
  publishPackage,
  setCategoryPackage,
  setIdPackage,
  clearPackageData,
  clearPublishPackageData
} from '@app/src/views/Package/listPackage';
import * as ImageManNewspaper from '@app/src/assets/img/man-newspaper.svg';
import { PackageModel } from '@app/src/views/Package/listPackage/models/PackageModel';
import { isClientEnv } from '@app/src/utils/validations';
import { useHistory } from 'react-router-dom';
import { clearValidateData, fetchValidate, setUserPasarella } from '@app/src/common/session';
import { CATEGORIES } from '@app/src/config/categories';
import { getAliasCategory } from '@app/src/utils/categories';
import { Icon } from '@app/src/common/Icon';

const isClient = isClientEnv();
const PAYMENT_URL = '/pago-paquete';
const PACKAGE_URL = '/compra-tu-paquete-de-avisos-impreso';
const SESSION_URL = '/inicia-tu-sesion';

export const ListPackage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const categories = useSelector(state => state.categories.data);
  const isLoading = useSelector(state => state.categories.isFetching);
  const isLoadingPackage = useSelector(state => state.package.isFetching);
  const packages = useSelector(state => state.package.data);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const isLoadingPublish = useSelector(state => state.package.isFetchingPublish);
  const publish = useSelector(state => state.package.dataPublish);
  const currentCategory = useSelector(state => state.package.categorySelected);
  const validate = useSelector(state => state.session.validate.data);
  const isLoadingValidate = useSelector(state => state.session.validate.isFetching);
  const [isPayment, setIsPayment] = useState(false);
  const [currentSelected, setCurrentSelected] = useState(null);
  const userData = useSelector(state => state.session.user.data);
  const getAliasFromPath = () => location.pathname.split('-')[3];
  const pathAlias = getAliasFromPath();
  const currentAlias = getAliasCategory(pathAlias);
  const categoryConfig = CATEGORIES[currentAlias];
  const [urlNextStep, setUrlNextStep] = useState('');

  useEffect(() => {
    if (currentAlias) {
      dispatch(setCategoryPackage(categoryConfig.id));
      dispatch(fetchPackage(categoryConfig.id));
    } else {
      dispatch(clearPackageData());
      dispatch(setCategoryPackage(''));
    }
  }, []);

  useEffect(() => {
    if (categories && categories.length === 0) {
      dispatch(fetchCategories());
    }
  }, [categories]);

  useEffect(() => {
    if (userStorage && userStorage.jwt && validate && validate.email && isPayment) {
      setIsPayment(false);
      dispatch(publishPackage(currentCategory, currentSelected))
      dispatch(clearValidateData());
    }
  }, [validate, currentCategory, currentSelected, isPayment]);

  useEffect(() => {
    if (publish && publish.unique_id) {
      dispatch(setIdPackage(currentSelected));
      const updateUser = {
        ...userStorage,
        packageId: currentSelected,
        categoryId: currentCategory,
        user: userData && userData.id,
        uniqueId: publish.unique_id
      };
      dispatch(clearPublishPackageData());
      isClient && localStorage.setItem('user', JSON.stringify(updateUser));
      history.push(`${urlNextStep}/${updateUser && updateUser.uniqueId}`);
    }
  }, [publish, currentCategory, urlNextStep]);

  const handleChange = (category) => {
    const { id, nameAlias, text } = category;
    pushDatalayerPackage(text, nameAlias);
    dispatch(setCategoryPackage(id));
    const updateUser = {
      ...userStorage,
      categoryId: id
    };
    isClient && localStorage.setItem('user', JSON.stringify(updateUser));
    if (id) {
      history.push(category.paths.purchasePackage.stepSelection);
    } else {
      history.push(PACKAGE_URL);
    }
  };

  const getUrlFromAlias = (alias: string) => {
    switch (alias) {
      case 'eco':
        return `-ec-${pathAlias}`;
      case 'eco-talan':
        return `-ec-tl-${pathAlias}`;
      case 'talan':
        return `-tl-${pathAlias}`;
      default:
        return '';
    }
  };

  const getTitleFromAlias = (alias: string, title: string) => {
    switch (alias) {
      case 'eco':
        return `${title} EC`;
      case 'eco-talan':
        return `${title} EC+Talán`;
      case 'talan':
        return `${title} Talán`;
      default:
        return '';
    }
  };

  const handleClickContract = (itemPackage) => {
    const { id, alias, title } = itemPackage;
    const nextUrl = PAYMENT_URL + getUrlFromAlias(alias);
    const titleLayer = getTitleFromAlias(alias, title);
    pushDatalayerPackage(titleLayer, categoryConfig.nameAlias);
    setUrlNextStep(nextUrl);
    setIsPayment(true);
    setCurrentSelected(id);
    dispatch(setUserPasarella('purchase-package'));
    dispatch(setIdPackage(id));
    const updateUser = {
      ...userStorage,
      payment: 'purchase-package',
      urlGenerated: getUrlFromAlias(alias),
      titleLayer
    };
    isClient && localStorage.setItem('user', JSON.stringify(updateUser));
    if (userStorage && userStorage.jwt) {
      dispatch(fetchValidate());
    } else {
      history.push(SESSION_URL, { from: 'purchase-package' });
    }
  };

  const pushDatalayerPackage = (productName: string, nameAlias) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EvPasosdecompra',
        'category': `P1_${productName}`,
        'action': nameAlias,
        'label': userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id,
        'value': 1
      })
    }
  };

  return (
    <React.Fragment>
      <Title>Elige tu paquete de avisos ideal</Title>
      <Content>
        <SelectWrapper
          dataList={hydrateDataSelectCategories(categories)}
          placeholder="Escoge una categoría"
          handleChange={handleChange}
          width={320}
          isLoading={isLoading}
          initialIndex={currentCategory}
        />
        {
          isLoadingPackage ?
            <LoaderWrapper>
              <Icon data-name='icon-circle' fill='#ccc' width={'30'} height={'30'} />
            </LoaderWrapper>
            :
            (packages && packages.length > 0) ?
              <React.Fragment>
                <ListWrapper>
                  {
                    packages.map((item: PackageModel, key) => (
                      <CardPackage
                        key={key}
                        title={item.title}
                        isRecommend={Boolean(item.recommended)}
                        subtitle={item.name}
                        discount={item.saving}
                        price={item.price}
                        priceRegular={item.priceRegular}
                        handleClick={() => handleClickContract(item)}
                        duration={item.duration}
                        detailAds={item.detail && item.detail.ads}
                        detailExtra={item.detail && item.detail.extracharges}
                        isLoading={(isLoadingValidate || isLoadingPublish) && item.id === currentSelected}
                      />
                    ))
                  }
                  <Disclaimer>Máximo 12 palabras por cada aviso del paquete contratado.</Disclaimer>
                </ListWrapper>
              </React.Fragment>
              :
              <Image src={ImageManNewspaper} alt="periódico" />
        }
      </Content>
    </React.Fragment>
  )
};
